import { apiClient, USE_MOCK } from "./apiClient";
import mockDb from "./mockDb";

export const QuotationService = {
  listQuotations: async () => {
    if (USE_MOCK) return mockDb.getQuotations();
    const { data } = await apiClient.get("/quotations");
    return data;
  },

  getQuotation: async (id) => {
    if (USE_MOCK) return mockDb.getQuotationById(id);
    const { data } = await apiClient.get(`/quotations/${id}`);
    return data;
  },

  createQuotation: async (payload) => {
    if (USE_MOCK) return mockDb.createQuotation(payload);
    const { data } = await apiClient.post("/quotations", payload);
    return data;
  },

  updateQuotation: async (id, payload) => {
    if (USE_MOCK) return mockDb.updateQuotation(id, payload);
    const { data } = await apiClient.put(`/quotations/${id}`, payload);
    return data;
  },

  deleteQuotation: async (id) => {
    if (USE_MOCK) return mockDb.deleteQuotation(id);
    await apiClient.delete(`/quotations/${id}`);
    return true;
  },

  markDownloaded: async (id) => {
    if (USE_MOCK) return mockDb.markDownloaded(id);
    const { data } = await apiClient.patch(`/quotations/${id}/downloaded`);
    return data;
  },

  sendQuotation: async (id) => {
    // Stub for now
    if (USE_MOCK) return mockDb.updateQuotation(id, { status: 'sent' }); // or sendQuotation
    const { data } = await apiClient.post(`/quotations/${id}/send`);
    return data;
  }
};
